/**
 * Configuration for the Taxonomy API
 */

// TODO: Finish this API configuration
export default {
	id: 'taxonomy',
	name: 'Taxonomy',
	resultsTitle: 'Universal Taxonomy',
	version: 'v1',
	fields: [],
};
